module.exports = __webpack_public_path__ + "static/media/criativos_feminino_acessorios.1d60b5ab.jpg";